import * as Yup from "yup";
import { withFormik } from "formik";

const mailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const passwordRegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/g;

const composeWithFormik = withFormik({
  enableReinitialize: true,
  displayName: 'RegisterForm', // helps with React DevTools
  mapPropsToValues: ({ values }: any) => values,
  handleSubmit: async (values: any, { props:{ setRegisterValues } }) => setRegisterValues(values, 1),
  validationSchema: ({ userCount, min = 5, passMin }) =>
    Yup.object().shape({
      displayName: Yup.string().nullable().required('users.name.full'.t()),
      mail: Yup.string()
        .nullable()
        .required('users.email.required'.t())
        .min(min, 'users.email.min'.t({ value: min }))
        .matches(mailRegExp, 'users.email.invalid'.t())
        .test('mail', 'users.email.existed'.t(), async function () {
          let { mail } = this.parent;
          try {
            if (mail.match(mailRegExp)) {
              const res = await userCount({ filter: { search: { keyword: mail, type: 'mail' } } });
              if (res?.count) {
                return false;
              }
            }
          } catch (e) {}
          return true;
        }),
      password: Yup.string()
        .nullable()
        .required('users.password.required'.t())
        .min(passMin, 'users.password.min'.t({ value: passMin }))
        .matches(passwordRegExp, 'users.password.validate'.t()),
      passwordConfirmation: Yup.string()
        .nullable()
        .oneOf([Yup.ref('password'), null], `users.passConfirm.invalid`.t())
        .required(`users.password.required`.t())
        .min(min, `users.password.min`.t({ value: passMin }))
    })
});


export default composeWithFormik